<template>
  <main>
    <v-dialog v-model="acceptDialog" max-width="420px">
      <DeleteModal
          title="Aceitar promoção dos produtos"
          textMessage="Tem certeza que quer aceitar a promoção dos produtos?"
          cancelBtn="Cancelar"
          okbtn="Aceitar"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(acceptDialog = false)"
          @action="acceptPromotion"
      />
    </v-dialog>

    <v-dialog v-model="refuseDialog" max-width="420px">
      <DeleteModal
          title="Recusar promoção dos produtos"
          textMessage="Tem certeza que quer recusar a promoção dos produtos?"
          cancelBtn="Cancelar"
          okbtn="Recusar"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(acceptDialog = false)"
          @action="refusePromotion"
      />
    </v-dialog>

    <Header
        buttonTitle="Criar promoção"
        title="Promoções"
        text="Promoções cadastradas"
        @action2="goToRoute('/promotion')"
        :haveAction="false"
        :haveBack="false"
        :haveCustomButton="false"
    />
    <v-card class="mx-2">
      <v-row cols="12">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="items"
              class="content-table"
              loading-text="Buscando..."
              no-data-text="Sem registros"
              hide-default-footer
          >
            <template v-slot:[`item.discountType`]="{ item }">
              {{ item.discountType === 1 ? 'Percentual' : 'Real' }}
            </template>

            <template v-slot:[`item.discount`]="{ item }">
              {{
                item.discountType === 1 ? `${item.discount} %` : item.discount.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>

            <template v-slot:[`item.start`]="{ item }">
              {{ item.end ? formatDate(item.start) : 'Sem registro' }}
            </template>

            <template v-slot:[`item.end`]="{ item }">
              {{ item.end ? formatDate(item.end) : 'Sem registro' }}
            </template>

            <template v-slot:[`item.promotionResales`]="{ item }">
              {{ !!item.promotionsResale.find((x) => x.resaleId === user.id) ? 'Sim' : 'Não' }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div style="display: flex; flex-direction: row; flex-wrap: nowrap">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        style="border-radius: 4px"
                        width="76"
                        height="35"
                        class="ma-1 table-button hidden-sm-and-down"
                        color="quaternary"
                        @click="detailsProduct(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <span>Detalhar</span>
                    </v-btn>
                  </template>
                  <span>Detalhes</span>
                </v-tooltip>

                <v-tooltip v-if="!!item.promotionsResale.find((x) => x.resaleId === user.id)" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        style="border-radius: 4px"
                        width="150"
                        height="35"
                        class="ma-1 table-button hidden-sm-and-down"
                        color="quaternary"
                        @click="refusePromotionModal(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <span>Recusar promoção</span>
                    </v-btn>
                  </template>
                  <span>Recusar promoção</span>
                </v-tooltip>

                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        style="border-radius: 4px"
                        width="150"
                        height="35"
                        class="ma-1 table-button hidden-sm-and-down"
                        color="quaternary"
                        @click="acceptPromotionModal(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <span>Aceitar promoção</span>
                    </v-btn>
                  </template>
                  <span>Aceitar promoção</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="filter.totalItems > filter.pageSize"
                    :currentPage="filter.currentPage"
                    :totalItems="filter.totalItems"
                    :page="filter.page"
                    :pageSize="filter.pageSize"
                    :totalPages="filter.totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </main>
</template>

<script lang="js">
import ApiService from '../../../services/ApiService';
import Header from "./components/Header";
import Utils from "../../../Utils/FormatDate";
import Vue from "vue";
import DeleteModal from "../components/DeleteModal";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "PromotionsCenter",
  components: {
    Pagination,
    Header,
    DeleteModal,
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.list()
  },

  data() {
    return {
      loading: false,
      user: null,
      apiService: new ApiService(),
      pageSize: 20,
      page: 1,
      totalPages: 1,
      totalItems: 1,
      currentPage: 1,
      filter: {
        pageSize: 20,
        page: 1,
        totalPages: 1,
        validateDate: true,
        active: true,
        products: [],
        resales: [],
      },
      headers: [
        {
          text: "Nome",
          value: "name",
          sortable: false,
          align: "center",
        },
        {
          text: "Tipo de desconto",
          value: "discountType",
          sortable: false,
          align: "center",
        },
        {
          text: "Desconto",
          value: "discount",
          sortable: false,
          align: "center",
        },
        {
          text: "Início",
          value: "start",
          sortable: false,
          align: "center",
        },
        {
          text: "Fim",
          value: "end",
          sortable: false,
          align: "center",
        },
        {
          text: "Aceitou a promoção?",
          value: "promotionResales",
          sortable: false,
          align: "center",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      items: [],
      currentPromotion: null,
      acceptDialog: false,
      refuseDialog: false,
      status: [
        {label: "Inativo", value: false},
        {label: "Ativo", value: true},
      ],
    }
  },

  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    async list() {
      this.loading = true;
      this.apiService.post('promotion/list', this.filter).then((response) => {
        this.items = response.promotions
        this.filter.totalPages = response.pager.totalPages
        this.filter.totalItems = response.pager.totalItems
        this.filter.currentPage = response.pager.currentPage
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },


    async backPage() {
      this.filter.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.list();
    },

    acceptPromotionModal(item) {
      this.currentPromotion = item;
      this.acceptDialog = true;
    },
    refusePromotionModal(item) {
      this.currentPromotion = item;
      this.refuseDialog = true;
    },
    acceptPromotion() {
      try {
        this.loading = true;
        this.currentPromotion.resales = [this.user.id]
        this.currentPromotion.doneByAdminOrMasterUser = false;
        this.apiService.post('promotion/add-resale', this.currentPromotion).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Promoção aceita com sucesso!",
            trace: null,
          });
          await this.list()
          this.acceptDialog = false
          this.loading = false;
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível aceitar promoção, verifique os campos e tente novamente!",
            trace: null,
          });
          this.acceptDialog = false
          this.loading = false;
        })
      } catch (e) {

      }
    },

    refusePromotion() {
      try {
        this.loading = true;
        this.refuseDialog = false;
        this.currentPromotion.promotionsToResale = [this.currentPromotion.promotionsResale.find((promotion) => promotion.resaleId === this.user.id).id]
        this.currentPromotion.doneByAdminOrMasterUser = false;
        this.currentPromotion.resaleId = this.user.id;
        this.apiService.post(`promotion/refuse`, this.currentPromotion).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Promoção recusada com sucesso!",
            trace: null,
          });
          await this.list()
          this.loading = false;
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível recusar promoção, verifique os campos e tente novamente!",
            trace: null,
          });
          this.loading = false;
        })
      } catch (e) {

      }
    },
    detailsProduct(item) {
      this.$router.push({
        path: "/promotion-resale",
        query: {details: true, id: item.id},
      });
    },
  },

  watch: {
    "filter.page": {
      deep: true,
      async handler() {
        await this.list()
      }
    },
  }
};
</script>

<style scoped>
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

</style>
